import { useState } from "react";
import CustomModal from "../shared/CustomModal";
import { Button } from "react-bootstrap";
import ExportApi from "../api/ExportApi";

const SendMarketingEmail = () => {
    const [showModal, setShowModal] = useState(false);
    const [isSending, setIsSending] = useState(false);

    const handleConfirmSend = async () => {
        setShowModal(false)
        setIsSending(true);

        try {
            ExportApi.SendMarketingEmail()
                .then((res) => {
                    if (res.data.success) {
                        setIsSending(false)
                    }
                })
                .catch((err) => {
                    console.error(err)
                });
        } catch (error) {
            setIsSending(false)
            console.error("Failed to send marketing email", error);
        }
    };

    return (
        <div>

            <div>
                <Button
                    variant="primary"
                    type="submit"
                    className="mt-4"
                    onClick={() => setShowModal(true)}
                    disabled={isSending}
                >
                    {/* {isButtonDisabled ? 'Submitting...' : 'Submit'} */}
                   {isSending ? "Sending..." : "Send Marketing Mail"}
                </Button>
                {/* {
                    isSending && (
                        <p className="text-danger py-2">
                            Please don’t refresh the page or leave the site while the email is being sent. This may take some time to complete.
                        </p>
                    )
                } */}

            </div>

            {/* Confirmation Modal */}
            <CustomModal
                show={showModal}
                handleClose={() => setShowModal(false)}
                headerText="Send Marketing Email"
                closeButtonText="Cancel"
                actionButtonText="Confirm"
                actionButton={handleConfirmSend}
                actionButtonDisable={isSending}
            >
                <p>
                    Are you sure you want to send the marketing email to all opted-in users?
                </p>
            </CustomModal>
        </div>
    );
};

export default SendMarketingEmail;
